import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getActions } from './actions.js';
import { getInitialState } from './helpers.js';
import { reducer } from './reducer.js';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';

const SolutionsEcommContext = /*#__PURE__*/ React.createContext({});
const useSolutionsEcommContext = ()=>React.useContext(SolutionsEcommContext)
;
const SolutionsEcommProvider = ({ children  })=>{
    const { activeVariant  } = useProductDetailContext();
    const initialState = React.useMemo(()=>getInitialState()
    , []);
    const [state, dispatch] = React.useReducer(reducer, initialState);
    const actions = React.useMemo(()=>getActions(dispatch)
    , []);
    const value = {
        actions,
        state
    };
    if (!CommerceToolsApi.isSolutions(activeVariant)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(SolutionsEcommContext.Provider, {
        value: value
    }, children);
};

export { SolutionsEcommContext, SolutionsEcommProvider, useSolutionsEcommContext };
//# sourceMappingURL=SolutionsEcommContext.js.map
